export const isTokenValid = (token: string) => {
    const validTokenShape = /\b[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-\b[0-9a-fA-F]{12}\b/;
    return validTokenShape.exec(token) || false;
};
